import React from "react";

function CubeIcon({ isActive }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m2 6 10-5 10 5M2 6v12l10 5M2 6l10 5m0 12 10-5V6M12 23V11m10-5-10 5" />
        </svg>
    );
}

export default CubeIcon;
